export const DEFAULT_REACTION_KIND = "LIKE";

export const REACTION_OPTIONS = [
  { kind: "LIKE", emoji: "❤️", label: "Нравится", colors: ["#ff4d6d", "#ff758f", "#ffa8b8"] },
  { kind: "FIRE", emoji: "🔥", label: "Огонь", colors: ["#fb5607", "#ff9f1c", "#ffbe0b"] },
  { kind: "INSIGHT", emoji: "💡", label: "Инсайт", colors: ["#4361ee", "#4895ef", "#90caf9"] },
  { kind: "SUPPORT", emoji: "🙌", label: "Поддержка", colors: ["#7b2d8b", "#a133b5", "#ce93d8"] },
  { kind: "APPLAUSE", emoji: "👏", label: "Аплодисменты", colors: ["#2a9d8f", "#48c78f", "#9deac9"] },
  { kind: "STAR", emoji: "⭐", label: "Важное", colors: ["#f5b81f", "#ffd166", "#ffe59a"] },
];

const REACTION_BY_KIND = REACTION_OPTIONS.reduce((acc, item) => {
  acc[item.kind] = item;
  return acc;
}, {});
const REACTION_KIND_ALIASES = {
  IDEA: "INSIGHT",
  HANDSHAKE: "APPLAUSE",
  CLAP: "APPLAUSE",
  HEART: "LIKE",
  LOVE: "LIKE",
  LIGHTBULB: "INSIGHT",
  BRAIN: "SUPPORT",
  FAVORITE: "STAR",
  FAVOURITE: "STAR",
};

export function normalizeReactionKind(value, fallback = null) {
  const raw = String(value || "")
    .trim()
    .toUpperCase();
  if (!raw) return fallback;
  const normalized = REACTION_KIND_ALIASES[raw] || raw;
  return Object.prototype.hasOwnProperty.call(REACTION_BY_KIND, normalized) ? normalized : fallback;
}

export function getReactionOption(kind) {
  const normalized = normalizeReactionKind(kind, DEFAULT_REACTION_KIND);
  return REACTION_BY_KIND[normalized] || REACTION_BY_KIND[DEFAULT_REACTION_KIND];
}

export function getReactionEmoji(kind) {
  return getReactionOption(kind).emoji;
}

export function getReactionPalette(kind) {
  return [...getReactionOption(kind).colors];
}
